import { action, computed, observable } from 'mobx';
import React from 'react';
import authStore from '../../0-common/store/AuthStore';
import { emitter, EVENTS } from '../../0-common/utils/EventEmitter';
import storeFactory from '../../0-common/utils/StoreFactory';

class ShopLoginStore {

	constructor(){
		this.init();
	}

	init(){
		//	Login Form
		this.username = React.createRef();
	    this.password = React.createRef();
	    //	Regiter Form
		this.name = React.createRef();
	    this.rusername = React.createRef();
	    this.rpassword = React.createRef();
	    this.mobilenumber = React.createRef();
	    //	Forgot password Form
	    this.fusername = React.createRef();
	    //	Reset Password Form
	    this.nPassword = React.createRef();
	    this.cPassword = React.createRef();
	}

	@observable isLoading = false;
	@observable isLoggingOut = false;
	@observable loggedOut = false;
	@observable userRegistrationActiveStep = 1;
	@observable userForgotPasswordActiveStep = 1;
	@observable resetChangePasswordForm = false;
	forgotPasswordUserEmailID = "";

	@observable loginValidStatus = {
		username : {
			empty : false,
			invalid : false,
			msg : ""
		},
		password : {
			empty : false,
			invalid : false,// never used, added for data model consistency.
			msg : ""
		}
	}

	@computed
	get isUsernameInValid(){
		return (this.loginValidStatus.username.empty || this.loginValidStatus.username.invalid)
	}

	@computed 
	get usernameErrorMsg(){
		return this.loginValidStatus.username.msg;
	}

	@computed 
	get isPasswordEmpty(){
		return (this.loginValidStatus.password.empty)
	}

	@computed 
	get passwordErrorMsg(){
		return this.loginValidStatus.password.msg;
	}

	@observable registerValidStatus = {
		name : {
			empty : false,
			invalid : false,
			msg : ""
		},
		rusername : {
			empty : false,
			invalid : false,
			msg : ""
		},
		rpassword : {
			empty : false,
			invalid : false,
			msg : ""
		},
		mobilenumber : {
			empty : false,
			invalid : false,
			msg : ""
		}
	}

	@computed
	get isRegisterNameInValid(){
		return (this.registerValidStatus.name.empty);
	}

	@computed
	get registerNameErrorMsg(){
		return this.registerValidStatus.name.msg;
	}

	@computed
	get isRegisterEmailInValid(){
		return (this.registerValidStatus.rusername.empty || this.registerValidStatus.rusername.invalid);
	}

	@computed
	get registerEmailErrorMsg(){
		return this.registerValidStatus.rusername.msg;
	}

	@computed
	get isRegisterPasswordInValid(){
		return (this.registerValidStatus.rpassword.empty || this.registerValidStatus.rpassword.invalid);
	}

	@computed
	get registerPasswordErrorMsg(){
		return this.registerValidStatus.rpassword.msg;
	}

	@computed
	get isRegisterMobilenumberInValid(){
		return (this.registerValidStatus.mobilenumber.empty || this.registerValidStatus.mobilenumber.invalid);
	}

	@computed
	get registerMobilenumberErrorMsg(){
		return this.registerValidStatus.mobilenumber.msg;
	}

	@observable verifyAccountValidStatus = {
		code : {
			empty : false,
			invalid : false,
			msg : ""
		},
		codeResend : {
			error : false,
			success : false,
			msg : "" 
		},
		updateEmail : {
			empty : false,
			invalid : false,
			error : false,
			success : false,
			msg : "" 
		}
	}

	@computed
	get isVerificationCodeInValid(){
		return (this.verifyAccountValidStatus.code.empty || this.verifyAccountValidStatus.code.invalid);
	}

	@computed
	get verificationCodeErrorMsg(){
		return this.verifyAccountValidStatus.code.msg;
	}

	@computed
	get isResendCodeFailed(){
		return (this.verifyAccountValidStatus.codeResend.error);
	}

	@computed
	get isResendCodeSuccess(){
		return (this.verifyAccountValidStatus.codeResend.success);
	}

	@computed
	get resendCodeStatusMsg(){
		return this.verifyAccountValidStatus.codeResend.msg;
	}

	@computed
	get isUpdateEmailInValid(){
		return (this.verifyAccountValidStatus.updateEmail.empty || this.verifyAccountValidStatus.updateEmail.invalid);
	}

	@computed
	get isUpdateEmailSuccess(){
		return (this.verifyAccountValidStatus.updateEmail.success);
	}

	@computed
	get updateEmailErrorMsg(){
		return this.verifyAccountValidStatus.updateEmail.msg;
	}

	@computed
	get updateEmailStatusMsg(){
		return this.verifyAccountValidStatus.updateEmail.msg;
	}

	@observable forgotPswdValidStatus = {
		fusername : {
			empty : false,
			invalid : false,
			msg : ""
		}
	}

	@computed
	get isforgotPswdEmailEmpty(){
		return (this.forgotPswdValidStatus.fusername.empty);
	}

	@computed
	get forgotPswdEmailErrorMsg(){
		return this.forgotPswdValidStatus.fusername.msg;
	}

	@observable changePswdValidStatus = {
		nPassword : {
			empty : false,
			invalid : false,
			mismatch : false,
			msg : ""
		},
		cPassword : {
			empty : false,
			invalid : false,
			mismatch : false,
			msg : ""
		}
	}

	@computed
	get isChangePswdInValid(){
		return (this.changePswdValidStatus.nPassword.empty || this.changePswdValidStatus.nPassword.invalid);
	}

	get isChangePswdConfirmInValid(){
		return (this.changePswdValidStatus.cPassword.empty || this.changePswdValidStatus.cPassword.mismatch);
	}

	@computed
	get changePswdErrorMsg(){
		return this.changePswdValidStatus.nPassword.msg;
	}

	@computed
	get changePswdConfirmErrorMsg(){
		return this.changePswdValidStatus.cPassword.msg;
	}

	scanStorage(){
		const isVisited = JSON.parse(localStorage.getItem('IC_Shop_Tracker'));
        if(!isVisited){
            storeFactory.NavigationStore.changeView(storeFactory.NavigationStore.VIEW.SHOPLOGIN, storeFactory.NavigationStore.SUBVIEW.SHOP.SIGNUP);
        }
	}

	ref = (fieldName) => {
		return this[fieldName];
	}

	get = (fieldName) => {
		const fieldRef = this[fieldName].current ? this[fieldName].current.inputRef.current : null;
		const value = fieldRef ? fieldRef.value : "";
		return value;
	}	

	reset = (fieldName) => {
		const fieldRef = this[fieldName].current ? this[fieldName].current.inputRef.current : null;
		if(fieldRef){
			fieldRef.value = "";
		}
	}

	get ForgotPasswordEmail(){
		return this.forgotPasswordUserEmailID;
	}

	@action.bound
	gotoLoginView(){
		this.resetLoginForm();
		this.resetLoginStatus();
    	storeFactory.NavigationStore.changeView(storeFactory.NavigationStore.VIEW.SHOPLOGIN, storeFactory.NavigationStore.SUBVIEW.SHOP.LOGIN);
	}

	@action.bound
	gotoRegisterView(){
		this.resetRegisterForm();
		this.resetRegisterStatus();

		this.userRegistrationActiveStep = 1;

    	storeFactory.NavigationStore.changeView(storeFactory.NavigationStore.VIEW.SHOPLOGIN, storeFactory.NavigationStore.SUBVIEW.SHOP.SIGNUP);
	}

	@action.bound
	gotoForgotPasswordView(){
		this.resetForgotPSWDForm();
		this.resetForgotPSWDStatus();

		this.resetVerifyAccountStatus();

		this.resetChangePSWDForm();
		this.resetChangePSWDStatus();

		this.userForgotPasswordActiveStep = 1;

    	storeFactory.NavigationStore.changeView(storeFactory.NavigationStore.VIEW.SHOPLOGIN, storeFactory.NavigationStore.SUBVIEW.SHOP.FORGOTPASSWORD);
	}

	@action
	resetLoginStatus = (fieldName) => {
		if(fieldName){
			this.loginValidStatus[fieldName] = {
				empty : false,
				invalid : false,
				msg : ""
			}
		} else {
			this.loginValidStatus = {
				username : {
					empty : false,
					invalid : false,
					msg : ""
				},
				password : {
					empty : false,
					invalid : false,
					msg : ""
				}
			}
		}
	}

	@action.bound
	resetRegisterStatus(fieldName){
		if(fieldName){
			this.registerValidStatus[fieldName] = {
				empty : false,
				invalid : false,
				msg : ""
			}
		} else {
			this.registerValidStatus = {
				name : {
					empty : false,
					invalid : false,
					msg : ""
				},
				rusername : {
					empty : false,
					invalid : false,
					msg : ""
				},
				rpassword : {
					empty : false,
					invalid : false,
					msg : ""
				},
				mobilenumber : {
					empty : false,
					invalid : false,
					msg : ""
				}
			}
		}
	}

	@action.bound
	resetVerifyAccountStatus(){
		this.verifyAccountValidStatus = {
			code : {
				empty : false,
				invalid : false,
				msg : ""
			},
			codeResend : {
				error : false,
				success : false,
				msg : "" 
			},
			updateEmail : {
				empty : false,
				invalid : false,
				error : false,
				success : false,
				msg : "" 
			}
		}
	}

	@action.bound
	resetForgotPSWDStatus(){
		this.forgotPswdValidStatus = {
			fusername : {
				empty : false,
				invalid : false,
				msg : ""
			}
		}
	}

	@action.bound
	resetChangePSWDStatus(){
		this.changePswdValidStatus = {
			nPassword : {
				empty : false,
				invalid : false,
				mismatch : false,
				msg : ""
			},
			cPassword : {
				empty : false,
				invalid : false,
				mismatch : false,
				msg : ""
			}
		}
	}

	resetLoginForm(){
	    this.reset("username");
	    this.reset("password");
	}

	resetRegisterForm(){
		this.reset("name");
		this.reset("mobilenumber");
		this.reset("rusername");
		this.reset("rpassword");
	}

	resetForgotPSWDForm(){
		this.reset("fusername");
	}

	resetChangePSWDForm(){
	    this.reset("nPassword");
	    this.reset("cPassword");
	}

	resetAll(){
		this.resetLoginStatus();
		this.resetLoginForm();

		this.resetRegisterStatus();
		this.resetRegisterForm();

		this.resetForgotPSWDStatus();
		this.resetForgotPSWDForm();

		this.resetChangePSWDStatus();
		this.resetChangePSWDForm();

		this.resetVerifyAccountStatus();

		this.isLoading = false;
	}

	/****************************************** SHOP LOGIN API ******************************************/

	@action.bound
	async executeLogin(sellerID, shopID){
		try {
			this.isLoading = true;
			this.resetLoginStatus();
			const username = this.get("username");
			const password = this.get("password");
			console.log("U :"+username+"  #. P : "+password);
			
			const isLoginFormValid = this.validateLoginForm();
			if(!isLoginFormValid){
				this.isLoading = false;
				return;
			}
			
			const response = await authStore.shopLogin(username, password, storeFactory.NavigationStore.currentLanguageName, sellerID, shopID);
			console.log(" Login Status : "+response.status);
			if(response.status) 
				this.onLoginSuccess(response.user);
			else
				this.onLoginFailure(response.error);
		}
		catch (error) {
			storeFactory.ErrorStore.log(error, "Couldn't login", "on executeLogin Error");
			this.onLoginFailure(error);
		}
		finally {
			this.isLoading = false;	
		}
	}

	validateLoginForm(){
		let isLoginFormValid = true;
		const username = this.get("username");
		const password = this.get("password");

		const emailCheckRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const isEmailValid = emailCheckRegex.test(username);
		if(username === ""){
			this.loginValidStatus.username.empty = true;
			this.loginValidStatus.username.msg = "Please enter your email address."
			isLoginFormValid = false;
		} else if(!isEmailValid){
			this.loginValidStatus.username.invalid = true;
			this.loginValidStatus.username.msg = "Please enter a valid email address."
			isLoginFormValid = false;
		} else {
			this.loginValidStatus.username.empty = false;
			this.loginValidStatus.username.invalid = false;
		}

		if(password === ""){
			this.loginValidStatus.password.empty = true;
			this.loginValidStatus.password.msg = "Please enter your password."
			isLoginFormValid = false;
		} else {
			this.loginValidStatus.password.empty = false;
		}

		return isLoginFormValid
	}

	@action.bound
	onLoginSuccess(user){
		storeFactory.ShopUserStore.CurrentUser = user.SUBJECT;
		storeFactory.ShopUserStore.CurrentUserTypeInfo = user.SUBJECT_TYPE;

		if(user.ORDER){
			const orderStore = storeFactory.fetchStore('PUBLICORDERSTORE', {"Type" : "ORDERS"});
			orderStore.initializeCart(user.ORDER);
		}

		localStorage.setItem('IC_Shop_Tracker', JSON.stringify(true));	
		storeFactory.NavigationStore.changeView(storeFactory.NavigationStore.VIEW.SHOP);
		this.resetLoginForm();
		this.resetLoginStatus();
		this.loggedOut = false;
		//window.location.reload();
		this.isLoading = false;
		emitter.emit(EVENTS.SHOP.USER.LOGIN, user.SUBJECT.DATA.Email);
		return false;
	}

	@action.bound 
	onLoginFailure(errorData){
		//this.resetLoginForm();
		this.isLoading = false;
		let errorMsg = errorData.message || "User Login Failed";
		if(errorData.EXCEPTION){
			errorMsg = errorData.EXCEPTION.Message || errorMsg;
			if(errorData.EXCEPTION.ClassName === "AuthenticationFailedException"){
				this.loginValidStatus.username.invalid = true;
				errorMsg = this.loginValidStatus.username.msg = "Your email or password is incorrect";
			}
			if(errorData.EXCEPTION.ClassName === "NoSuchUserException"){
				this.loginValidStatus.username.invalid = true;
				errorMsg = this.loginValidStatus.username.msg = "Your email is not registered with us";
			}
		}
		emitter.emit(EVENTS.SHOP.ERROR, errorMsg, "Login Page");
	}

	/****************************************************************   REGISTER API   ****************************************************************/

	@action.bound
	async executeRegister(sellerID, shopID){
		try{
			this.isLoading = true;
			this.resetRegisterStatus();
			const name = this.get("name");
			const username = this.get("rusername");
			const password = this.get("rpassword");
			const mobilenumber = this.get("mobilenumber");
			
			const isRegisterFormValid = this.validateUserRegistrationForm();
			if( !isRegisterFormValid ){
				this.isLoading = false;
				return;
			}

			const response = await authStore.shopRegister(name, username, password, mobilenumber, storeFactory.NavigationStore.currentLanguageName, sellerID, shopID);
			console.log(" Register Status : "+response.status);
			if(response.status)
				this.onRegisterSuccess(response.user);
			else
				this.onRegisterFailure(response.error);
		}
		catch (error) {
			storeFactory.ErrorStore.log(error, "Couldn't Register", "on executeRegister Error");
			this.onRegisterFailure(error);
		}
		finally {
			this.isLoading = false;	
		}
	}

	validateUserRegistrationForm(){

		let isRegisterFormValid = true;
		
		const name = this.get("name");
		const username = this.get("rusername");
		const password = this.get("rpassword");
		const mobilenumber = this.get("mobilenumber");
		
		//Name Field validation
		if(name === ""){
			this.registerValidStatus.name.empty = true;
			this.registerValidStatus.name.msg = "Please enter your name."
			isRegisterFormValid = false;
		} else {
			this.registerValidStatus.name.empty = false;
		}

		//Email Field validation
		const emailCheckRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		const isEmailValid = emailCheckRegex.test(username);
		if(username === ""){
			this.registerValidStatus.rusername.empty = true;
			this.registerValidStatus.rusername.msg = "Please enter your email address."
			isRegisterFormValid = false;
		} else if(!isEmailValid){
			this.registerValidStatus.rusername.invalid = true;
			this.registerValidStatus.rusername.msg = "Please enter a valid email address."
			isRegisterFormValid = false;
		} else {
			this.registerValidStatus.rusername.empty = false;
			this.registerValidStatus.rusername.invalid = false;
		}

		//Password Field validation
		if(password === ""){
			this.registerValidStatus.rpassword.empty = true;
			this.registerValidStatus.rpassword.msg = "Password cannot be empty."
			isRegisterFormValid = false;
		} else if(password.length < 8){
			this.registerValidStatus.rpassword.invalid = true;
			this.registerValidStatus.rpassword.msg = "Password must be atleast 8 characters."
			isRegisterFormValid = false;
		} else {
			this.registerValidStatus.rpassword.empty = false;
			this.registerValidStatus.rpassword.invalid = false;
		}

		//MobileNumber Field validation
		const mobileNumberCheckRegex = /^\d{10}$/;
		const isMobileNumberValid = mobileNumberCheckRegex.test(mobilenumber);
		if(mobilenumber === ""){
			this.registerValidStatus.mobilenumber.empty = true;
			this.registerValidStatus.mobilenumber.msg = "Please enter your mobile number."
			isRegisterFormValid = false;
		} else if(!isMobileNumberValid){
			this.registerValidStatus.mobilenumber.invalid = true;
			this.registerValidStatus.mobilenumber.msg = "Mobile number must be valid and contain 10 digits."
			isRegisterFormValid = false;
		} else {
			this.registerValidStatus.mobilenumber.empty = false;
			this.registerValidStatus.mobilenumber.invalid = false;
		}

		return isRegisterFormValid;
	}

	@action.bound
	onRegisterFailure(errorData){
		this.isLoading = false;
		let errorMsg = errorData.message || "User Registration Failed";
		if(errorData.EXCEPTION){
			if(errorData.EXCEPTION.ClassName === "UserAlreadyExistsException"){
				this.registerValidStatus.rusername.invalid = true;
				this.registerValidStatus.rusername.msg = errorData.EXCEPTION.Message;
			}
			errorMsg = errorData.EXCEPTION.Message;
		}
		emitter.emit(EVENTS.SHOP.ERROR, errorMsg, "Register Page");
	}

	@action.bound
	onRegisterSuccess(user){
		storeFactory.ShopUserStore.CurrentUser = user.SUBJECT;
		storeFactory.ShopUserStore.CurrentUserTypeInfo = user.SUBJECT_TYPE;
		this.isLoading = false;
		localStorage.setItem('IC_Shop_Tracker', JSON.stringify(true));
		this.resetRegisterStatus();
		this.userRegistrationActiveStep++;
		emitter.emit(EVENTS.SHOP.USER.SIGNUP, user.SUBJECT.DATA.Email);
	}

	/*********************************************************   VERIFY ACCOUNT API   ********************************************************/

	@action.bound
	async executeVerifyUserAccount(verificationCode, context, sellerID, shopID){
		try{
			this.isLoading = true;
			let emailID = "";
			switch (context){
				case 'RESET_PASSWORD' :
					emailID = this.forgotPasswordUserEmailID;
					break;

				case 'USER_REGISTRATION':
					emailID = this.registeredUserEmailID;
					break;
			}
			if(verificationCode === ""){
				this.verifyAccountValidStatus.code.empty = true;
				this.verifyAccountValidStatus.code.msg = "Please enter the verification code.";
				this.isLoading = false;
				return;
			}

			const status = await authStore.shopVerifyUserAccount(emailID, verificationCode, context, storeFactory.NavigationStore.currentLanguageName, sellerID, shopID);
			if(status){
				console.log("Verify Account Status : "+status);
				this.onVerifyUserAccountSuccess();
			} else {
				this.onVerifyUserAccountError();
			}
		}
		catch (error) {
			storeFactory.ErrorStore.log(error, "Couldn't verify account", "on executeChangePassword Error");
			this.onVerifyUserAccountError();
		}
		finally {
			this.isLoading = false;
		}
	}

	@action.bound
	onVerifyUserAccountError(){
		this.isLoading = false;
		this.resetVerifyAccountStatus();
		this.verifyAccountValidStatus.code.invalid = true;
		this.verifyAccountValidStatus.code.msg = "The code you have entered is not valid.";
		//storeFactory.ErrorStore.log(value('lb_uv_error'), value('lb_uv_error'), "execute Verify User Account");
	}

	@action.bound
	onVerifyUserAccountSuccess(){
		this.isLoading = false;
		localStorage.setItem('IC_Shop_Tracker', JSON.stringify(true));
		this.resetVerifyAccountStatus();
		this.userRegistrationActiveStep++;
		this.userForgotPasswordActiveStep++;
	}

	/*********************************************************   RESEND OTP API   ********************************************************/

	@action.bound
	async executeResendCode(context, sellerID, shopID){
		try{
			this.isLoading = true;
			let emailID = "";
			switch (context){
				case 'RESET_PASSWORD' :
					emailID = this.forgotPasswordUserEmailID;
					break;

				case 'USER_REGISTRATION':
					emailID = this.registeredUserEmailID;
					break;
			}
			await authStore.shopResendCode(emailID, context, sellerID, shopID);
		}
		catch (error) {
			storeFactory.ErrorStore.log(error, "Couldn't resend code", "on executeResendCode Error");
		}
		finally {
			this.onResendCodeDone();
		}
	}

	@action.bound
	onResendCodeDone(){
		this.isLoading = false;
		this.resetVerifyAccountStatus();
		this.verifyAccountValidStatus.codeResend.success = true;
		this.verifyAccountValidStatus.codeResend.msg = "New verification code sent successfully."
	}

	/*********************************************************   FORGOT PASSWORD API   ********************************************************/

	@action.bound
	async executeForgotPassword(sellerID, shopID){
		try{
			this.isLoading = true;
			const username = this.get("fusername");
			console.log("U :"+username);
			
			//Email Field validation
			if(username === ""){
				this.forgotPswdValidStatus.fusername.empty = true;
				this.forgotPswdValidStatus.fusername.msg = "Please enter your email address."
				this.isLoading = false;
				return false;
			} else {
				this.forgotPswdValidStatus.fusername.empty = false;
				this.forgotPswdValidStatus.fusername.invalid = false;
			}

			const status = await authStore.shopForgotPassword(username, storeFactory.NavigationStore.currentLanguageName, sellerID, shopID);
			console.log(" Forgot Pass Status : "+status);
			this.forgotPasswordUserEmailID = username;
			this.onForgotPasswordDone(status);
		}
		catch (error) {
			storeFactory.ErrorStore.log(error, "Couldn't execute forgot password", "on executeForgotPassword Error");
		}
		finally {
			this.isLoading = false;	
		}
	}

	@action.bound
	onForgotPasswordDone(status){
		this.resetForgotPSWDStatus();
		this.isLoading = false;
		localStorage.setItem('IC_Shop_Tracker', JSON.stringify(true));
		this.userForgotPasswordActiveStep++;
	}

	/*********************************************************   RESET PASSWORD API   ********************************************************/

	@action.bound
	async executeChangePassword(sellerID, shopID){
		try{
			this.isLoading = true;
			const username = this.forgotPasswordUserEmailID;
			const newPassword = this.get("nPassword");
			const cpassword = this.get("cPassword");

			//Password Field validation
			if(newPassword === ""){
				this.changePswdValidStatus.nPassword.empty = true;
				this.changePswdValidStatus.nPassword.msg = "Password cannot be empty."
				this.isLoading = false;
				return false;
			} else if(newPassword.length < 8){
				this.changePswdValidStatus.nPassword.invalid = true;
				this.changePswdValidStatus.nPassword.msg = "Password must be atleast 8 characters."
				this.isLoading = false;
				return false;
			} else {
				this.changePswdValidStatus.nPassword.empty = false;
				this.changePswdValidStatus.nPassword.invalid = false;
			}

			if(cpassword === ""){
				this.changePswdValidStatus.cPassword.empty = true;
				this.changePswdValidStatus.cPassword.msg = "Password cannot be empty."
				this.isLoading = false;
				return false;
			}

			if(newPassword === cpassword) {
				const status = await authStore.shopResetPassword(username, newPassword, storeFactory.NavigationStore.currentLanguageName, sellerID, shopID);
				console.log(" Reset Password Status : "+status);
				this.onChangePasswordDone();
			} else {
				this.onChangePasswordMismatch();
			}
		}
		catch (error) {
			storeFactory.ErrorStore.log(error, "Couldn't change password", "on executeChangePassword Error");
		}
		finally {
			this.isLoading = false;	
		}
	}

	@action.bound
	onChangePasswordMismatch(){
		this.isLoading = false;
		this.resetChangePSWDStatus();
		this.changePswdValidStatus.cPassword.mismatch = true;
		this.changePswdValidStatus.cPassword.msg = "Please make sure your passwords match.";
	}

	@action.bound
	onChangePasswordDone(){
		this.resetChangePSWDForm();
		this.resetChangePSWDStatus();
		this.isLoading = false;
		localStorage.setItem('IC_Shop_Tracker', JSON.stringify(true));
		this.userForgotPasswordActiveStep++;
	}

	/***************************************** CHANGE LANGUAGE API  ***************************************** */

	@action.bound
	executeChangeLanguage(lang){
		storeFactory.NavigationStore.setCurrentLang(lang);
		//Autorun attached to language change in languageStore
	}

	/***************************************** LOGOUT API  ***************************************** */

	@action.bound
	async executeLogout(sellerID, shopID){
		try{
			this.isLoggingOut = true;
			this.loggedOut = false;
			const status = await authStore.shopLogout(sellerID, shopID);
			console.log(" Login Status : "+status);
			if(status) 
				this.onLogoutSuccess();
			else
				this.onLogoutFailure();
		}
		catch (error) {
			storeFactory.ErrorStore.log(error, "Couldn't logout", "on executeLogout Error");
			this.onLogoutFailure();
		}
		finally {
			this.isLoggingOut = false;
		}
	}

	@action.bound
	onLogoutSuccess(){
		this.resetLoginForm();
		storeFactory.ShopUserStore.reset();
		const orderStore = storeFactory.fetchStore("PUBLICORDERSTORE", {"Type" : "ORDERS"});
		orderStore.reset();
		const shopAddressStore = storeFactory.fetchStore("SHOPADDRESS");
		shopAddressStore.reset();
		const shopStore = storeFactory.fetchStore("PUBLICWEBSHOPS");
		storeFactory.NavigationStore.changeView(storeFactory.NavigationStore.VIEW.SHOP);
		shopStore.ActivePage = shopStore.DefaultShopPageID;
		this.loggedOut = true;
	}

	@action.bound
	onLogoutFailure(){
		this.resetLoginForm();
		storeFactory.ShopUserStore.reset();
		const orderStore = storeFactory.fetchStore("PUBLICORDERSTORE", {"Type" : "ORDERS"});
		orderStore.reset();
		const shopStore = storeFactory.fetchStore("PUBLICWEBSHOPS");
		storeFactory.NavigationStore.changeView(storeFactory.NavigationStore.VIEW.SHOP);
		shopStore.ActivePage = shopStore.DefaultShopPageID;
		this.loggedOut = false;
	}
}

export default new ShopLoginStore(); 